import {
  Box,
  GridItem,
  Typography,
  IconArrowForward,
  IconClear,
  ProChip,
} from '@capitalise/ui-design-system';
import PropTypes from 'prop-types';
import { Analytics } from 'utils/Analytics';
import { AnalyticsEventAction, AnalyticsEventCategory } from 'enums/analytics-types';
import { PaymentOrigin, useRedirectTrackingPaymentOrigin } from '@capitalise/common';

const UpgradeBanner = ({ handleClose }) => {
  const { redirectToPaymentFlow } = useRedirectTrackingPaymentOrigin();
  const handleClick = () => {
    Analytics.track(AnalyticsEventCategory.business, AnalyticsEventAction.upgradeStart, {
      extraParams: {
        upgradeOrigin: 'credit profile banner',
      },
    });
    redirectToPaymentFlow(PaymentOrigin.CREDIT_PROFILE);
  };

  return (
    <GridItem
      colSpan={{ sm: 12 }}
      backgroundColor="green-500"
      borderBottom="1px solid"
      borderColor="grey-50"
      display="flex"
      justifyContent="space-between"
    >
      <Box display="flex" alignItems="center" p="4xsmall">
        <ProChip variant="dark" color="green" />
        <Box pl="4xsmall">
          <Typography size="body-16" color="white">
            Upgrade your plan to access your full Experian credit profile
          </Typography>
        </Box>
      </Box>
      <Box display="flex" alignItems="center">
        <Box
          display="flex"
          cursor="pointer"
          onClick={handleClick}
          alignItems="center"
          data-testid="compare-button"
          mr="2xsmall"
        >
          <Typography size="heading-14" color="white">
            Compare plans
          </Typography>
          <Box ml="tiny">
            <IconArrowForward color="white" width="2xsmall" />
          </Box>
        </Box>
        <Box
          width="small"
          height="small"
          backgroundColor="green-400"
          cursor="pointer"
          borderRadius="100px"
          onClick={handleClose}
          display="flex"
          justifyContent="center"
          alignItems="center"
          mr="3xsmall"
        >
          <IconClear width="3xsmall" color="white" />
        </Box>
      </Box>
    </GridItem>
  );
};
UpgradeBanner.propTypes = {
  handleClose: PropTypes.func,
};
export default UpgradeBanner;
